
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Site } from "@/services/types";

interface SiteCardServicesProps {
  site: Site;
}

const SiteCardServices = ({ site }: SiteCardServicesProps) => {
  return (
    <>
      <Separator className="my-4" />
      
      <div className="flex flex-wrap gap-2">
        {site.services.map((service, index) => (
          <Badge key={index} variant="outline" className="bg-fabre-lightgreen text-fabre-darkgreen border-fabre-green">
            {service}
          </Badge>
        ))}
      </div>
    </>
  );
};

export default SiteCardServices;
